import React, { Component } from 'react';
import { EntityList } from '../../../components/EntityList';
import {withRouter } from 'react-router-dom';

class StatementImport extends Component {

    constructor() {
        super();
    }

    render() {        
        return <p>StatementImport</p>
    }
}

export default withRouter(StatementImport);